<template>
  <div class="">
    <h6 class="font-weight-bold mb-3">Shipping address</h6>
    <div class="gird-row">
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">Name</span>-->
        <span class="">{{ order?.shipping_first_name }} {{ order?.shipping_last_name }}</span>
      </div>
<!--      <div class="d-flex flex-column">-->
<!--&lt;!&ndash;        <span class="text-muted mb-2">Company</span>&ndash;&gt;-->
<!--        <span class="">{{ order?.shipping_company }}</span>-->
<!--      </div>-->
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">Address</span>-->
        <span class="">{{ order?.shipping_address_1 }}<span v-if="order?.shipping_address_2 ">,</span> {{ order?.shipping_address_2 }}</span>
      </div>
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">City</span>-->
        <span class="">{{ order?.shipping_city }}, {{order?.shipping_state}}, {{order?.shipping_zip}}</span>
      </div>
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">Country</span>-->
        <span class="">{{ order?.shipping_country }}</span>
      </div>
<!--      <div class="d-flex flex-column">-->
<!--&lt;!&ndash;        <span class="text-muted mb-2">State</span>&ndash;&gt;-->
<!--        <span class="">{{ order?.shipping_state }}</span>-->
<!--      </div>-->
      <div class="d-flex flex-column">
        <!--        <span class="text-muted mb-2">Phone</span>-->
        <span class="">{{ order?.shipping_phone }}</span>
      </div>
      <div class="d-flex flex-column">
        <!--        <span class="text-muted mb-2">Shipping method</span>-->
        <span class="">{{ order?.shipping_method }}</span>
      </div>
      <div class="d-flex flex-column">
<!--        <span class="text-muted mb-2">Tax Number</span>-->
        <span class="">{{ order?.shipping_tax_no }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillingAddress",
  props:['order'],

}
</script>

<style scoped lang="scss">
.gird-row {
  display: grid;
  width: 100%;
  gap: 5px;
  //grid-template-columns: repeat(9, 1fr);
  margin-bottom: 1rem;
  //padding: 10px 15px;

}
h6 {
  font-size: 18px;
}
</style>
